export const EXTERNAL_LINK = {
  CUSTOMER_SERVICE_CENTER: 'https://lin.ee/eNY9yaC',
  LOGIN_CUSTOMER_SERVICE: 'https://page.line.me/994sshgp?openQrModal=true',
  // 幫助中心固定頁面（後台 FAQ 文章 / 分類的「網站固定連結」指定）；站內路徑不含語系，<a href> 要用 localizePath 補上
  CUSTOMER_SERVICE_CENTER_HK: '/help/go/customer-service?country_code=HK',
  EINVOICE_GOVERNMENT_INFORMATION: 'https://www.einvoice.nat.gov.tw/?CSRT=6201288656407980614',
  BECOME_MERCHANT: 'https://landingpage.tutorabcshop.com/LandingPage/MerchantsRecruitment/Index',
  BECOME_KOL: 'https://landingpage.tutorabcshop.com/LandingPage/KOLRecruitment/Index',
  FAQ: '/help',
  TERMS_OF_SERVICE: '/help/terms',
  TERMS_OF_SERVICE_HK: '/help/terms?country_code=HK',
  RETURN_POLICY: '/help/go/return-policy',
  RETURN_REFUND_APPLICATION_FORM: 'https://forms.gle/mPSqjaGR2ASNo8WbA',
  CVS_RETURN_INSTRUCTIONS: '/help/go/cvs-return-instructions',
  OFFLINE_RETURN_APPLICATION_FORM: 'https://docs.google.com/forms/d/e/1FAIpQLSeSGrsLnXF1KfMNehRLLbcvf_JkMhZ7P5l8uWKHyp2sp425RQ/viewform',
  STRAWBERRY_OFFICIAL_SITE: 'https://www.strawberrynet.com',
  PCHOME_OFFICIAL_SITE: 'https://s.tutorabcshop.com/4ZoUos',
  LIVE_MALL_CLUB_RETURN_POLICY: 'https://s3.tutorabc.com/shop/return_policy_jp.PDF',
  FACEBOOK_BASE_PROFILE_URL: 'https://www.facebook.com/',
  INSTAGRAM_BASE_PROFILE_URL: 'https://www.instagram.com/',
  LIVE_MALL_CLUB_OPEN_STORE_AGREEMENT: 'https://s3.tutorabc.com/shop/Live%20Mall%20Club_Vendor%20Agreement_Draft.pdf',
  LIVE_MALL_CLUB_SERVICE_EMAIL: 'support@livemallclub.com',
  ECOSMETICS_OFFICIAL_SITE: 'https://www.ecosmetics.com',
  ECPAY_FLUTTER_APP_RETURN_URL: 'tutorshop://payment-complete',
  FIVE_STAR_OFFICIAL_SITE: 'https://www.pacificpinesports.com/',
  ACMILAN_OFFICIAL_SITE: 'https://www.acmilan.com/',
  UDESIGN_OFFICIAL_SITE: 'https://udesign.uniicreative.com/mall/cus/cat/Cc1c01.do?dc_cateid_0=0_059_049_934_396',
  // 條款類：/terms/* 讀幫助中心固定頁面；_EN 是香港站版本
  LEGAL_DECLAIMER: '/terms/legal-disclaimer',
  LEGAL_DECLAIMER_EN: '/terms/legal-disclaimer?country_code=HK',
  PRIVACY_POLICY: '/terms/privacy-policy',
  PRIVACY_POLICY_EN: '/terms/privacy-policy?country_code=HK',
  USER_TERMS: '/terms/user-terms',
  USER_TERMS_EN: '/terms/user-terms?country_code=HK',
  APP_STORE: 'https://openapp.tutorabc.com/frontstage/app/shopstore?wetsite=T&os=ios',
  GOOGLE_PLAY: 'https://openapp.tutorabc.com/frontstage/app/shopstore?wetsite=T&os=android',
  EGL_TOURS_OFFICIAL_SITE: 'https://www.egltours.com/website/home',
  TEN_MART_OFFICIAL_SITE:
    'https://ddei5-0-ctp.trendmicro.com:443/wis/clicktime/v1/query?url=https%3a%2f%2freurl.cc%2fK95bZM&umid=1FBEF8EB-3ED2-AD06-85A8-01E57CF9AC68&auth=69faf84a43364ce84cc693d7299b709c1804e7c4-e7f458df8cad0cfc23049b5868ac065cb10b3aac',
  SOTHEBYS_OFFICIAL_SITE: 'https://www.sothebyswine.com/hk/en-primeur/bordeaux-en-primeur-2024?s=1',
  CORNEY_BARROW_OFFICIAL_SITE: 'https://corneyandbarrow.com.hk/',
  CORNEY_BARROW_CONTACT_EMAIL: 'ida.weatherall@corneyandbarrow.com',
  CORNEY_BARROW_INSTAGRAM: 'https://www.instagram.com/corneyandbarrowhk/?hl=en',
  WINNER_PICKLE_BALL_OFFICIAL_SITE: 'https://winnerpickleball.com/',
  PACIFIC_PINE_SPORTS_OFFICIAL_SITE: 'https://www.pacificpinesports.com/',
  KB_JEWELS_OFFICIAL_SITE: 'https://kbjewels.com',
  KIYAAN_JEWELLERY_INSTAGRAM: 'https://www.instagram.com/kiyaan_jewels.hk/?hl=en',
  KIYAAN_JEWELLERY_LINKEDIN: 'https://hk.linkedin.com/in/kinchit-shah-abb283135',
  PXEC_OFFICIAL_SITE:
    'https://ddei5-0-ctp.trendmicro.com/wis/clicktime/v1/query?url=https://customer-uat.box.pxec.com.tw/&umid=B17C096C-47F1-DB06-AC00-1D7E4F25534D&auth=69faf84a43364ce84cc693d7299b709c1804e7c4-038d3afb78b26eec27d93842f8afa79101edddb8',
  SQUARE_RECORDS_OFFICIAL_SITE: 'https://www.instagram.com/squarerecords.tps/',
  SQUARE_RECORDS_CONTACT_EMAIL: 'blairreeve@gmail.com',
  HKFEC_OFFICIAL_SITE: 'https://hkfec.org/',
  HKFEC_COM360_SITE: 'https://com360ai.com/',
  HKFEC_CONTACT_EMAIL: 'joseph@hkfec.org',
  HKFEC_FACEBOOK: 'https://www.facebook.com/hkfec.org',
  HKFEC_LINKEDIN: 'https://www.linkedin.com/company/hkfec/',
  XORRO_OFFICIAL_SITE: 'https://xorro.io/',
  XORRO_LINKEDIN: 'https://www.linkedin.com/company/xorro1/',
  XORRO_SIGNUP: 'https://login.xorro.io/login',
  AREA02_OFFICIAL_SITE: 'https://www.area02.com/?srsltid=AfmBOopa6OM9Hw70_IdRnyTwVk0d02_wDABlm5hIgiGb1xUjqunMdX5U',
  GLOBAL_MALL_OFFICIAL_SITE:
    'https://gmonline.twglobalmall.com/?utm_source=google&utm_medium=PMax&gad_source=1&gad_campaignid=21718100810&gbraid=0AAAAAozWrtj09FquIADX-EKwxWyfD9fs0&gclid=CjwKCAjw9PvWBhAxEiwAddzYyXnqS-DgiabJBYNhv3ggKK4PYf1dbfRb_3eYcd8sa8kvz9ht4h3cdxoC3RMQAvD_BwE',
}
